import writeOffScreenshot1 from "@me-team/common/src/images/tutorial/write-off-screenshot_1.png";
import writeOffScreenshot2 from "@me-team/common/src/images/tutorial/write-off-screenshot_2.png";
import writeOffScreenshot3 from "@me-team/common/src/images/tutorial/write-off-screenshot_3.png";
import writeOffScreenshot4 from "@me-team/common/src/images/tutorial/write-off-screenshot_4.png";
import saleProductsScreenshot0 from "@me-team/common/src/images/tutorial/sale-products-screenshot_0.png";
import saleProductsScreenshot1 from "@me-team/common/src/images/tutorial/sale-products-screenshot_1.png";
import saleProductsScreenshot2 from "@me-team/common/src/images/tutorial/sale-products-screenshot_2.png";
import saleProductsScreenshot3 from "@me-team/common/src/images/tutorial/sale-products-screenshot_3.png";
import saleProductsScreenshot4 from "@me-team/common/src/images/tutorial/sale-products-screenshot_4.png";

export const LOCAL_STORAGE_ACTIVE = "warehouseTutorialActive";
export const LOCAL_STORAGE_STEP = "warehouseTutorialStep";
export const LOCAL_STORAGE_START_PATH = "warehouseTutorialStartPath";
export const LOCAL_STORAGE_TYPE = "warehouseTutorialType";
export const LOCAL_STORAGE_CREATED_ID = "warehouseTutorialCreatedId";
export const LOCAL_STORAGE_CREATED_TECH_MAP_ID = "warehouseTutorialCreatedTechMapId";

export const writeOffScreenshots: { step: number; src: string }[] = [
    { step: 16, src: writeOffScreenshot1 },
    { step: 17, src: writeOffScreenshot2 },
    { step: 18, src: writeOffScreenshot3 },
    { step: 19, src: writeOffScreenshot4 },
];

export const saleFromRecordScreenshots: { step: number; src: string }[] = [{ step: 10, src: saleProductsScreenshot0 }];

export const saleProductsScreenshots: { step: number; src: string }[] = [
    { step: 16, src: saleProductsScreenshot1 },
    { step: 17, src: saleProductsScreenshot2 },
    { step: 18, src: saleProductsScreenshot3 },
    { step: 19, src: saleProductsScreenshot4 },
];
